import { render, staticRenderFns } from "./m-document-share.vue?vue&type=template&id=406adac6&scoped=true&lang=pug"
import script from "./m-document-share.vue?vue&type=script&lang=js"
export * from "./m-document-share.vue?vue&type=script&lang=js"
import style0 from "./m-document-share.vue?vue&type=style&index=0&id=406adac6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406adac6",
  null
  
)

export default component.exports